// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".07331d1fe864f9f7cb09eddaad01e4b4.js";
};